import { render } from "./InputChangepoint.vue?vue&type=template&id=38f7ffa6&scoped=true"
import script from "./InputChangepoint.vue?vue&type=script&lang=js"
export * from "./InputChangepoint.vue?vue&type=script&lang=js"

import "./InputChangepoint.vue?vue&type=style&index=0&id=38f7ffa6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38f7ffa6"]])

export default __exports__